import {Button, Stack} from '@primer/react'
import {clsx} from 'clsx'

interface Props {
  isSaving: boolean
  onSave: () => void
  onCancel: () => void
  className?: string
}

export function DefinitionFormActions({isSaving, onSave, onCancel, className}: Props) {
  return (
    <Stack direction="horizontal" gap="condensed" className={clsx('mt-4', className)}>
      <Button variant="primary" disabled={isSaving} onClick={onSave}>
        {isSaving ? 'Saving...' : 'Save property'}
      </Button>

      <Button onClick={onCancel}>Cancel</Button>
    </Stack>
  )
}
